<template>
    <div class="addressBookCard_container">
        <div class="cardTitle">{{ channeLabel }}</div>
        <div class="deleteIcon">
            <van-icon name="delete-o" size="18" @click="deleteChannel" />
        </div>
        <div class="addressText">{{ address }}</div>
        <span class="addressLabel">{{ chainType }}</span>
    </div>
    <van-popup v-model:show="show" class="deleteConfirmPopup">
        <div class="confirmPopTitle">{{ $t('withdraw.confirmDeleteAddress') }}</div>

        <div class="buttonGroup">
            <div class="cancelBtn" @click="cancelDelete">{{ $t('withdraw.cancel') }}</div>
            <div class="confirmBtn" @click="confirmDelete">{{ $t('withdraw.confirm') }}</div>
        </div>
    </van-popup>
    <status-popup ref="statusRef" :is-show-success="isSuccess" :content="toastContent"/>
</template>
<script lang="ts" setup>
import StatusPopup from '@/components/common/statusPopup.vue';
import { deleteNetwork } from '@/view/withdraw/supportScript';
import { ref } from 'vue';

const props = defineProps({
    address: {
        type: String,
        default: () => ''
    },
    channeLabel: {
        type: String,
        default: () => ''
    },
    chainType: {
        type: String,
        default: () => ''
    }
})
const emits = defineEmits(['updateAddressBook'])
const show = ref(false)
const isSuccess = ref(false)
const toastContent = ref('')
const statusRef = ref()
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const deleteChannel = () => {
    show.value = true
}
const cancelDelete = () => {
    show.value = false
}
const confirmDelete = async () => {
    const { data } = await deleteNetwork(props.address)
    if (data.code == 200) {
        showSuccess(data.msg)
         emits('updateAddressBook')
    } else {
        showError(data)
    }

}
</script>
<style scoped>
.addressBookCard_container {
    border-radius: 10px;
    border: 2px solid rgb(13, 176, 174) !important;
    padding: 25px 15px;
    margin: 10px 0;
}

.cardTitle {
    color: #fff;
    font-weight: bold;
    font-size: 14px;
}

.deleteIcon {
    display: flex;
    justify-content: right;
}

.addressText {
    color: #ccc;
    padding: 10px 0;
}

.addressLabel {
    background: rgb(1 50 50);
    padding: 4px;
}

.deleteConfirmPopup {
    border-radius: 15px;
    border: 0.5px solid #046ACC !important;
    background: #101629  !important;
    box-shadow:  inset 0px -3px 0px 0px #014b89, inset 0px 3px 0px 0px #014b89;
    padding: 25px 15px;
}
.confirmPopTitle{
    font-size: 15px;
    color: #fff;
    padding: 10px;
    display: flex;
    justify-content: center;
}
.buttonGroup{
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.cancelBtn{
    margin: 10px;
    font-size: 14px;
    color: #fff;
    padding: 10px;
    background: #ffffff55;
    border-radius: 5px;
}
.confirmBtn{
    margin: 10px;
    font-size: 14px;
    color: #fff;
    padding: 10px;
    background: linear-gradient(180deg, #35A5F8 0%, #0268CB 100%);
    border-radius: 5px;
}
</style>